export const useFormSubmit = () => {
  const submitForm = ({ action, method, fields }) => {
    const form = document.createElement('form');
    form.method = method;
    form.action = action;

    // Add hidden inputs for each field
    Object.entries(fields).forEach(([key, value]) => {
      if (value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      }
    });

    document.body.appendChild(form);

    form.submit();

    document.body.removeChild(form);
  };

  return { submitForm };
};
